// extracted by mini-css-extract-plugin
export default {"industryModel":"styles_industryModel__guf4M","boxModel":"styles_boxModel__YJ56N","cross":"styles_cross__hFw4J"};